import React from "react";
import { FormButton } from "../../Styles/Global.Styled";
import { Spinner } from "../../Styles/Animated.Styled";

const FormSubmissionBttn = ({
  text = "",
  icon,
  disabled = false,
  isLoading = false,
  customStyle,
  mbCustomStyle,
}) => {
  return (
    <FormButton
      type="submit"
      disabled={disabled || isLoading}
      $baseStyle={customStyle}
      $mStyle={mbCustomStyle}
    >
      {isLoading ? <Spinner /> : text}
      {icon && icon}
    </FormButton>
  );
};

export default FormSubmissionBttn;
